import { createHash } from "crypto";

export type CronActionTokenInput =
  | {
      kind: "declarative";
      deployId: string;
      name: string;
      pattern: string;
      procedureName: string;
    }
  | {
      kind: "runafter";
      deployId: string;
      procedureName: string;
    };

export function computeCronActionToken(input: CronActionTokenInput): string {
  const message =
    input.kind === "declarative"
      ? `${input.deployId}:cron:${input.name}:${input.pattern}:${input.procedureName}`
      : `${input.deployId}:runafter:${input.procedureName}`;
  return `cj_${createHash("sha256").update(message).digest("base64url").slice(0, 22)}`;
}
